import React, { useEffect, useState, useCallback, useRef } from 'react';
import moment from 'moment';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Avatar,
  AvatarGroup,
  Box,
  Tooltip,
  Typography,
  IconButton,
  Stack,
  TablePagination,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import SearchIcon from '@mui/icons-material/Search';
import {
  BsBoxArrowInUpRight,
  BsArrowDownCircle,
  BsPlusCircle,
  BsFilter,
  BsFillStickiesFill,
} from 'react-icons/bs';
import ExcelJS from 'exceljs';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import {
  ModalFormDetail,
  SearchInputColumnNew,
  DatePicker,
  SelectionSearchColumn,
  TextInputSearchColumn,
  DatePickerSearchColumn,
} from 'components';
import {
  RESPONSE_STATUSES,
  TASK_JOB_STATUS_OPTIONS,
  TASK_JOB_STATUS_OBJECT,
} from 'commons/constants';

import ApiServices from 'services';
import { FormDetail } from './form-detail';
import Utils from 'commons/utils';
import { debounce, pad } from 'lodash';
import { ContainerHeader, ButtonAdd, ButtonImport, ButtonExport } from './styles';

import { UpdateJob } from './update-job';
import { UpdateSubJob } from './update-sub-job';

import { RenderTaskJobStatus } from 'components/custom-status';
import { TablePaginationActions } from './table-pagination-actions';

import { LoadingView } from '../../components/loading-view';

const COLLAPSE_INIT = true;

// const renderStatus = (status) => {
//   const jobStatus = {
//     0: 'Kế hoạch',
//     1: 'Đang làm',
//     2: 'Chờ đánh giá',
//     3: 'Hoàn thành',
//   };

//   return jobStatus[status] || '';
// };

const renderCreateBy = (row, usersList) => {
  const user = usersList?.find((item) => item?.code === row?.createdBy);

  if (user) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar
          alt={user.code}
          src={`${process.env.REACT_APP_API_URL}/${user?.urlAvatar}`}
          // sx={{ width: 28, height: 28 }}
        />
        <Box sx={{ ml: 1 }}>
          <Box sx={{ fontWeight: 500 }}>{user?.code}</Box>
          {/* <Box sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>({user?.code})</Box> */}
        </Box>
      </Box>
    );
  }
  return row?.createdBy;
};

const renderUserFollow = (arrUser, usersList) => {
  if (!arrUser?.length) return '';

  const userManager = usersList?.filter((item) => arrUser?.includes(item?.code));

  if (!userManager?.length) return '';

  return (
    <AvatarGroup max={5} sx={{ marginLeft: 'auto', marginRight: '15px', cursor: 'pointer' }}>
      {userManager.map((item) => (
        <Tooltip key={item?.code} title={item.name} placement="top-start" arrow>
          <Avatar
            alt={item.code}
            src={`${process.env.REACT_APP_API_URL}/${item?.urlAvatar}`}
            // sx={{ width: 28, height: 28 }}
          />
        </Tooltip>
      ))}
    </AvatarGroup>
  );
};

function Row(props) {
  const {
    row,
    deleteItem,
    setSelected,
    usersList,
    handleShowDetailMainJob,
    handleShowDetailSubJob,
  } = props;
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    if (row) {
      setOpen(row?.isCollapse);
    }
  }, [row]);

  const strDateStart = moment().format('YYYY-MM-DD HH:mm');
  const strDateEnd = moment(row?.endWork).format('YYYY-MM-DD HH:mm');
  const dateStart = moment(strDateStart);
  const dateEnd = moment(strDateEnd);
  const compare = dateEnd.isBefore(dateStart);

  return (
    <React.Fragment>
      {/* // ================== Main Job ==================
          // ================== Main Job ==================
          // ================== Main Job ==================
          // ================== Main Job ================== */}
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
          }}
        >
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {row?.submenus?.length > 0 ? (
              open ? (
                <KeyboardArrowDownIcon style={{ color: 'blue', transition: '0.25s' }} />
              ) : (
                <KeyboardArrowRightIcon style={{ color: 'blue', transition: '0.25s' }} />
              )
            ) : (
              <></>
            )}
          </IconButton>
        </TableCell>
        <TableCell
          align="center"
          style={{ fontWeight: '400' }}
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
          }}
        >
          <Box sx={{ width: '80px' }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => handleShowDetailMainJob(row)}
            >
              <BorderColorIcon />
            </IconButton>
            <IconButton
              sx={{ marginLeft: '5px' }}
              aria-label="expand row"
              size="small"
              onClick={() => window.showConfirm(() => deleteItem(row))}
            >
              <HighlightOffIcon style={{ color: 'red' }} />
            </IconButton>
          </Box>
        </TableCell>
        <TableCell
          align="center"
          style={{ fontWeight: '400' }}
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
            color: compare ? 'red' : 'black',
          }}
        >
          {row?.code}
        </TableCell>
        <TableCell
          align="center"
          style={{ fontWeight: '400' }}
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
            color: compare ? 'red' : 'black',
          }}
        >
          {row?.name}
        </TableCell>
        <TableCell
          align="center"
          style={{ fontWeight: '400' }}
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
          }}
        >
          {/* {renderStatus(row?.status)} */}
          <RenderTaskJobStatus status={row?.status} />
        </TableCell>
        <TableCell
          align="center"
          style={{ fontWeight: '400' }}
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
            color: compare ? 'red' : 'black',
          }}
        >
          {row?.arrParentClientCompany?.map((item) => item?.code)?.join(', ')}
        </TableCell>
        <TableCell
          align="center"
          style={{ fontWeight: '400' }}
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
            color: compare ? 'red' : 'black',
          }}
        >
          {row?.beginWork && Utils.formatDateFn(row.beginWork)}
        </TableCell>
        <TableCell
          align="center"
          style={{ fontWeight: '400' }}
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
            color: compare ? 'red' : 'black',
          }}
        >
          {row?.endWork && Utils.formatDateFn(row.endWork)}
        </TableCell>

        {/* <TableCell
          align="center"
          style={{ fontWeight: '400' }}
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
            color: compare ? 'red' : 'black',
          }}
        >
          {row?.workUpdateResult}
        </TableCell> */}
        <TableCell
          align="center"
          style={{ fontWeight: '400' }}
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
            color: compare ? 'red' : 'black',
          }}
        >
          {renderCreateBy(row, usersList)}
        </TableCell>
        <TableCell
          align="center"
          style={{ fontWeight: '400' }}
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
          }}
        >
          {renderUserFollow(row?.arrManager || [], usersList)}
        </TableCell>
        <TableCell
          align="center"
          style={{ fontWeight: '400' }}
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
          }}
        >
          {renderUserFollow(row?.arrAssigner || [], usersList)}
        </TableCell>

        <TableCell
          align="center"
          style={{ fontWeight: '400' }}
          sx={{
            borderColor: 'blue',
            borderLeft: '1px solid blue',
            borderRight: '1px solid blue',
            color: compare ? 'red' : 'black',
          }}
        >
          {row?.workObjective}
        </TableCell>
      </TableRow>
      {/* // ================== Sub Job ==================
          // ================== Sub Job ==================
          // ================== Sub Job ==================
          // ================== Sub Job ================== */}
      {open && (
        <>
          {row?.submenus?.map((sub, indexSub) => {
            return (
              <TableRow
                key={`${sub?.code}-${sub?.parent}-${indexSub}`}
                sx={{
                  // backgroundColor: '#f5f5f5',
                  backgroundColor: '#E8F9FF',
                  boxShadow: '5px 5px 10px 0 #eee',
                }}
              >
                {row?.submenus?.length === indexSub + 1 ? (
                  <TableCell sx={{ borderBottom: '1px solid blue' }}>
                    <b
                      style={{
                        marginLeft: '10px',
                      }}
                    ></b>
                  </TableCell>
                ) : (
                  <TableCell sx={{ border: 'none' }}>
                    <b
                      style={{
                        marginLeft: '10px',
                      }}
                    ></b>
                  </TableCell>
                )}

                <TableCell
                  align="center"
                  sx={{
                    borderColor: 'blue',
                    borderLeft: '1px solid blue',
                  }}
                >
                  <Box sx={{ width: '80px' }}>
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => handleShowDetailSubJob(sub)}
                    >
                      <BorderColorIcon />
                    </IconButton>
                    <IconButton
                      sx={{ marginLeft: '5px' }}
                      aria-label="expand row"
                      size="small"
                      onClick={() => window.showConfirm(() => deleteItem(sub))}
                    >
                      <HighlightOffIcon style={{ color: 'red' }} />
                    </IconButton>
                  </Box>
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    borderColor: 'blue',
                    borderLeft: '1px solid blue',
                    color: compare ? 'red' : 'black',
                  }}
                >
                  {sub?.code}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    borderColor: 'blue',
                    borderLeft: '1px solid blue',
                    color: compare ? 'red' : 'black',
                  }}
                >
                  {sub?.name}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    borderColor: 'blue',
                    borderLeft: '1px solid blue',
                  }}
                >
                  {/* {renderStatus(sub?.status)} */}
                  <RenderTaskJobStatus status={sub?.status} />
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    borderColor: 'blue',
                    borderLeft: '1px solid blue',
                    color: compare ? 'red' : 'black',
                  }}
                >
                  {sub?.clientCompanyCode}
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    borderColor: 'blue',
                    borderLeft: '1px solid blue',
                    color: compare ? 'red' : 'black',
                  }}
                >
                  {sub?.beginWork && Utils.formatDateFn(sub.beginWork)}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    borderColor: 'blue',
                    borderLeft: '1px solid blue',
                    color: compare ? 'red' : 'black',
                  }}
                >
                  {sub?.endWork && Utils.formatDateFn(sub.endWork)}
                </TableCell>

                {/* <TableCell
                  align="center"
                  sx={{
                    borderColor: 'blue',
                    borderLeft: '1px solid blue',
                    color: compare ? 'red' : 'black',
                  }}
                >
                  {sub?.workUpdateResult}
                </TableCell> */}
                <TableCell
                  align="center"
                  sx={{
                    borderColor: 'blue',
                    borderLeft: '1px solid blue',
                    color: compare ? 'red' : 'black',
                  }}
                >
                  {renderCreateBy(sub, usersList)}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    borderColor: 'blue',
                    borderLeft: '1px solid blue',
                  }}
                >
                  {renderUserFollow(sub?.arrManager || [], usersList)}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    borderColor: 'blue',
                    borderLeft: '1px solid blue',
                  }}
                >
                  {renderUserFollow(sub?.arrAssigner || [], usersList)}
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    borderColor: 'blue',
                    borderLeft: '1px solid blue',
                    borderRight: '1px solid blue',
                    color: compare ? 'red' : 'black',
                  }}
                >
                  {sub?.workObjective}
                </TableCell>
              </TableRow>
            );
          })}
        </>
      )}
    </React.Fragment>
  );
}

const START_DATE = moment().startOf('month').format();
const END_DATE = moment().endOf('date').format();
const IS_NOT_SUCCESS_INIT = true;
// ================== TaskJobPage ==================
// ================== TaskJobPage ==================
// ================== TaskJobPage ==================
// ================== TaskJobPage ==================

const TaskJobPage = () => {
  const inputRef = useRef();
  const [originData, setOriginData] = useState([]);
  const [dataFormat, setDataFormat] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState(null);
  const [filterColumn, setFilterColumn] = useState(null);

  const [loadingExport, setLoadingExport] = useState(false);
  const [usersList, setUsersList] = useState([]);
  // search Date
  const [startDate, setStartDate] = useState(START_DATE);
  const [endDate, setEndDate] = useState(END_DATE);

  const [selectedShowModal, setSelectedShowModal] = useState(null);
  const [selectedUpdateSubJob, setSelectedUpdateSubJob] = useState(null);
  const [dataMainBySubJob, setDataMainBySubJob] = useState(null);

  const [searchStatus, setSearchStatus] = useState('all');
  const [searchBeginWork, setSearchBeginWork] = useState(null);
  const [searchEndWork, setSearchEndWork] = useState(null);

  // checkbox
  const [isNotSuccess, setIsNotSuccess] = useState(IS_NOT_SUCCESS_INIT);
  const [textDateSearch, setTextDateSearch] = useState('');
  const [textCheckboxSearch, setTextCheckboxSearch] = useState('');

  // paging
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const initData = async (query, queryColumn = null) => {
    let isNotSuccessValue = IS_NOT_SUCCESS_INIT;
    if (!query) {
      isNotSuccessValue = IS_NOT_SUCCESS_INIT;
    } else {
      isNotSuccessValue = query?.IsNotSuccess;
    }

    const newQuery = {
      DateFrom: query?.DateFrom
        ? Utils.convertToDateFormat_New(query?.DateFrom)
        : Utils.convertToDateFormat_New(START_DATE),
      DateTo: query?.DateTo
        ? Utils.convertToDateFormat_New(query?.DateTo)
        : Utils.convertToDateFormat_New(END_DATE),
      IsNotSuccess: `${isNotSuccessValue}`,
    };

    setLoading(true);
    try {
      const res = await ApiServices.getSchedulePersonUsers(newQuery);
      if (res?.data) {
        const filterParent = res?.data?.filter((el) => !el?.parentScheduleUserCode);
        setTotalRecords(filterParent?.length || 0);

        const pagingDataFormat = filterParent.filter((_, indexPaging) => {
          return page * rowsPerPage <= indexPaging && indexPaging < (page + 1) * rowsPerPage;
        });

        const dataFormat = pagingDataFormat?.map((item) => {
          const filterSubmenu = res?.data?.filter(
            (element) => element?.parentScheduleUserCode === item?.code,
          );
          item.submenus = filterSubmenu || [];
          item.isCollapse = COLLAPSE_INIT;
          return item;
        });

        // setDataFormat(dataFormat || []);
        const dataOriginFormat = res?.data?.map((originItem) => {
          originItem.clientSearch = !originItem?.parentScheduleUserCode
            ? originItem?.arrParentClientCompany?.map((el) => el.code)?.join(' ') || ''
            : originItem?.clientCompanyCode;

          return originItem;
        });

        setOriginData(dataOriginFormat || []);

        //  confirm filter
        if (queryColumn) {
          setFilterColumn((prev) => {
            return { ...prev, queryColumn };
          });
        } else {
          setDataFormat(dataFormat || []);
        }

        const preTextDateStart = moment(newQuery?.DateFrom).format('DD-MM-YYYY');
        const preTextDateEnd = moment(newQuery?.DateTo).format('DD-MM-YYYY');
        setTextDateSearch(`${preTextDateStart} - ${preTextDateEnd}`);

        const preTextCheckbox = newQuery?.IsNotSuccess ? 'đã' : 'chưa';
        setTextCheckboxSearch(` ${preTextCheckbox} bao gồm các công việc chưa hoàn thành`);
      }
    } catch (err) {
      console.warn('initData - getSchedulePersonUsers:', err);
    }
    setLoading(false);
  };

  const getUsers = async () => {
    try {
      const res = await ApiServices.getUsers();
      if (res?.data) {
        setUsersList(res?.data || []);
      }
    } catch (error) {
      console.log('getUsers Failed:::', error);
    }
  };

  const handleFilterData = (query, dataInit) => {
    let dataFilter = [];

    dataInit?.map((item) => {
      let checkFilter = true;

      if (query?.code) {
        if (!Utils.convertValSearch(item?.code)?.includes(Utils.convertValSearch(query?.code))) {
          checkFilter = false;
        }
      }
      if (query?.name) {
        if (!Utils.convertValSearch(item?.name)?.includes(Utils.convertValSearch(query?.name))) {
          checkFilter = false;
        }
      }
      if (query?.clientSearch) {
        if (
          !Utils.convertValSearch(item?.clientSearch)?.includes(
            Utils.convertValSearch(query?.clientSearch),
          )
        ) {
          checkFilter = false;
        }
      }
      if (query?.createdBy) {
        if (
          !Utils.convertValSearch(item?.createdBy)?.includes(
            Utils.convertValSearch(query?.createdBy),
          )
        ) {
          checkFilter = false;
        }
      }
      if (query?.arrManager) {
        if (
          !Utils.convertValSearch(item?.arrManager?.join(',')).includes(
            Utils.convertValSearch(query?.arrManager),
          )
        ) {
          checkFilter = false;
        }
      }

      if (query?.arrAssigner) {
        if (
          !Utils.convertValSearch(item?.arrAssigner?.join(',')).includes(
            Utils.convertValSearch(query?.arrAssigner),
          )
        ) {
          checkFilter = false;
        }
      }
      if (query?.workObjective) {
        if (
          !Utils.convertValSearch(item?.workObjective)?.includes(
            Utils.convertValSearch(query?.workObjective),
          )
        ) {
          checkFilter = false;
        }
      }
      if (query?.workUpdateResult) {
        if (
          !Utils.convertValSearch(item?.workUpdateResult)?.includes(
            Utils.convertValSearch(query?.workUpdateResult),
          )
        ) {
          checkFilter = false;
        }
      }
      if (query?.beginWork) {
        if (moment(item?.beginWork).format('YYYY-MM-DD') !== query?.beginWork) {
          checkFilter = false;
        }
      }
      if (query?.endWork) {
        if (moment(item?.endWork).format('YYYY-MM-DD') !== query?.endWork) {
          checkFilter = false;
        }
      }
      if (query?.status) {
        if (item?.status !== +query?.status) {
          checkFilter = false;
        }
      }

      if (checkFilter) {
        dataFilter.push(item);
        return;
      } else {
        return;
      }
    });

    const filterParent = dataInit?.filter((el) => !el?.parentScheduleUserCode);
    const dataParentIsFilter = dataFilter
      ?.filter((parentIsFilter) => !parentIsFilter?.parentScheduleUserCode)
      ?.map((isFilter) => isFilter?.id);

    const dataFormat = filterParent
      ?.map((item) => {
        const filterSubmenu = dataFilter?.filter(
          (element) => element?.parentScheduleUserCode === item?.code,
        );
        item.submenus = filterSubmenu || [];
        item.isCollapse =
          query?.code ||
          query?.name ||
          query?.workObjective ||
          query?.workUpdateResult ||
          query?.beginWork ||
          query?.endWork ||
          query?.status ||
          query?.createdBy ||
          query?.arrManager ||
          query?.arrAssigner
            ? true
            : false;
        return item;
      })
      ?.filter(
        (dataFormatFilter) =>
          dataFormatFilter?.submenus?.length || dataParentIsFilter?.includes(dataFormatFilter?.id),
      );

    //
    setTotalRecords(dataFormat?.length || 0);
    setPage(0);

    // const newRowPerPage = +event.target.value;
    // const pageSetup = 0;

    // setRowsPerPage(newRowPerPage);
    // setPage(pageSetup);

    // const filterParent = originData?.filter((el) => !el?.parentScheduleUserCode);

    // const pagingDataFormat = filterParent.filter((_, indexPaging) => {
    //   return (
    //     pageSetup * newRowPerPage <= indexPaging && indexPaging < (pageSetup + 1) * newRowPerPage
    //   );
    // });

    //

    setDataFormat(dataFormat || []);
  };

  const timeoutGetData_Init = useCallback(
    debounce((newFilter, newFilterColumn) => {
      initData(newFilter, newFilterColumn);
    }, 500),
    [],
  );
  useEffect(() => {
    timeoutGetData_Init(filter, filterColumn);
  }, [filter]);

  useEffect(() => {
    getUsers();
  }, []);

  const reloadData = async () => {
    return await initData(filter, filterColumn);
  };

  const timeoutGetData = useCallback(
    debounce((newFilter, dataInit) => {
      handleFilterData(newFilter, dataInit);
    }, 500),
    [],
  );

  useEffect(() => {
    if (originData?.length) {
      timeoutGetData(filterColumn, originData);
    }
  }, [filterColumn]);

  const onColumnSearch = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    setFilterColumn((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleSearchSelect = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    setSearchStatus(value);

    if (value === 'all') value = '';

    setFilterColumn((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleChangeSearchBeginWork = (event) => {
    const date = event.target.value;
    setSearchBeginWork(date);
    const dateSearch = date ? moment(date).format('YYYY-MM-DD') : null;
    setFilterColumn((prev) => {
      return { ...prev, beginWork: dateSearch };
    });
  };
  const handleChangeSearchEndWork = (event) => {
    const date = event.target.value;
    setSearchEndWork(date);
    const dateSearch = date ? moment(date).format('YYYY-MM-DD') : null;
    setFilterColumn((prev) => {
      return { ...prev, endWork: dateSearch };
    });
  };

  const handleChangeCheckboxIsNotSuccess = (event) => {
    const val = event?.target?.checked;
    setIsNotSuccess(val);
    // setFilterColumn((prev) => {
    //   return { ...prev, isNotSuccess: val };
    // });
  };

  const deleteItem = async (row) => {
    if (!row?.id) return;

    setLoading(true);
    return ApiServices.deleteScheduleUser(row?.id)
      .then((res) => {
        if (res.status === RESPONSE_STATUSES.OK) {
          window.UIMessage?.success('Xóa thành công');
          reloadData();
        }
      })
      .catch((err) => {
        // window.UIMessage?.error('Xóa thất bại !!!');
        console.warn('deleteClientComplaint', err);
      })
      .finally(() => setLoading(false));
  };

  const validateValue = (row) => {
    const dataSelect = row;
    dataSelect.beginWork = Utils.checkIsDate(row.beginWork)
      ? Utils.convertToDateTimeFormat(row.beginWork)
      : '';
    dataSelect.endWork = Utils.checkIsDate(row.endWork)
      ? Utils.convertToDateTimeFormat(row.endWork)
      : '';
    return dataSelect;
  };
  const onCloseModal = () => {
    setSelectedShowModal(null);
  };
  const handleShowDetailMainJob = (row) => {
    const dataSelect = validateValue(row);
    setSelectedShowModal(dataSelect);
  };

  // Sub Job
  const handleCloseModalUpdateSubJob = () => {
    setSelectedUpdateSubJob(null);
    setDataMainBySubJob(null);
  };
  const handleShowDetailSubJob = (row) => {
    const dataMain = originData?.find((item) => item?.code === row?.parentScheduleUserCode);
    setDataMainBySubJob(dataMain);

    const dataSelect = validateValue(row);

    setSelectedUpdateSubJob(dataSelect);
  };

  const reloadDataAfterUpdateSubJob = () => {
    handleCloseModalUpdateSubJob();
    reloadData();
  };

  const handleChangeStartDate = useCallback(
    (event) => {
      setStartDate(event.target.value);
    },
    [startDate],
  );
  const handleChangeEndDate = useCallback(
    (event) => {
      setEndDate(event.target.value);
    },
    [endDate],
  );

  const handleSearchDate = (startDateSearch, endDateSearch, isNotSuccess) => {
    if (!startDateSearch || !endDateSearch) return;
    setFilter((prev) => ({
      ...prev,
      DateFrom: startDateSearch,
      DateTo: endDateSearch,
      IsNotSuccess: isNotSuccess,
    }));
  };

  // =======================================  Export Excel   =====================================================================

  const exportExcel = async (dataExport, filterNew) => {
    if (loading) return;
    setLoadingExport(true);
    const workbook = new ExcelJS.Workbook();
    // Ten sheet
    const sheetSummary = workbook.addWorksheet('DS CÔNG VIỆC', {
      properties: { tabColor: { argb: 'FF00FF00' } },
      views: [{ state: 'frozen', ySplit: 3, activeCell: 'A1', showGridLines: false }],
    });
    // sheetSummary.properties.defaultRowHeight = 30;
    sheetSummary.properties.defaultColWidth = 15;

    sheetSummary.getCell('F2').value = 'DANH SÁCH CÔNG VIỆC';
    sheetSummary.mergeCells('F3:G3');
    sheetSummary.getCell('F3').value = `${moment(filterNew?.DateFrom).format(
      'DD/MM/YYYY',
    )} -> ${moment(filterNew?.DateTo).format('DD/MM/YYYY')}`;

    sheetSummary.getRow(2).font = {
      name: 'Arial',
      family: 2,
      size: 16,
      bold: true,
    };
    sheetSummary.getRow(3).alignment = { vertical: 'middle', horizontal: 'center' };

    const arrDetail = await dataExport?.map((item, index) => {
      const dataItem = [
        item?.stt, // STT
        item?.code, // Mã CV
        item?.name, // Tên CV
        item?.workObjective, // Mục Tiêu
        item?.workUpdateResult || '', // Kết Quả
        item?.parentScheduleUserCode ? 'CON' : 'CHA', // Cấp CV
        item?.parentScheduleUserCode || '', // Công Việc Cha
        item?.statusText || '', // Trạng Thái
        item?.arrAssignerText, // Người Thực Hiện
        item?.arrManagerText, // Người Liên Quan
        item?.arrParentClientCompanyText, // Khách Hàng
        item?.beginWork && new Date(moment(item?.beginWork).format('YYYY-MM-DD')), // Bắt Đầu
        item?.endWork && new Date(moment(item?.endWork).format('YYYY-MM-DD')), // Kết Thúc
      ];
      return dataItem;
    });

    // Add Table
    await sheetSummary.addTable({
      name: 'TableSummary',
      ref: 'B5',
      headerRow: true,
      totalsRow: false,
      style: {
        theme: 'TableStyleMedium23', // 23
        // showRowStripes: true,
      },
      columns: [
        { name: 'STT', totalsRowLabel: '', filterButton: false },
        { name: 'Mã Công Việc', filterButton: false },
        { name: 'Tên Công việc', filterButton: false },
        { name: 'Mục Tiêu', filterButton: false },
        { name: 'Kết Quả', filterButton: false },
        { name: 'Cấp CV', filterButton: false },
        { name: 'Công Việc Cha', filterButton: false },
        { name: 'Trạng Thái', filterButton: false },
        { name: 'Người Thực Hiện', filterButton: false },
        { name: 'Người Liên Quan', filterButton: false },
        { name: 'Khách Hàng', filterButton: false },
        { name: 'Bắt Đầu', filterButton: false },
        { name: 'Kết Thúc', filterButton: false },
      ],
      rows: arrDetail,
    });
    // Styles
    sheetSummary.getColumn(1).width = 2; // #
    sheetSummary.getColumn(2).width = 10; // STT
    sheetSummary.getColumn(3).width = 20; // Mã Công Việc
    sheetSummary.getColumn(4).width = 30; // Tên Công việc
    sheetSummary.getColumn(5).width = 30; // Mục Tiêu
    sheetSummary.getColumn(6).width = 20; // Kết Quả
    sheetSummary.getColumn(7).width = 10; // Cấp CV
    sheetSummary.getColumn(8).width = 20; // Công Việc Cha
    sheetSummary.getColumn(9).width = 18; // Trạng Thái
    sheetSummary.getColumn(10).width = 20; // Người Thực Hiện
    sheetSummary.getColumn(11).width = 20; // Người Liên Quan
    sheetSummary.getColumn(12).width = 30; // Khách Hàng
    sheetSummary.getColumn(13).width = 15; // Bắt Đầu
    sheetSummary.getColumn(14).width = 15; // Kết Thúc

    sheetSummary.getColumn(4).alignment = {
      wrapText: true,
      // vertical: 'top',
    };
    sheetSummary.getColumn(5).alignment = {
      wrapText: true,
      // vertical: 'top',
    };
    sheetSummary.getColumn(12).alignment = {
      wrapText: true,
      // vertical: 'top',
    };
    sheetSummary.getRow(5).alignment = { vertical: 'middle', horizontal: 'center' };
    sheetSummary.getRow(5).height = 30;

    dataExport.forEach((dataFont, indexDataFont) => {
      if (dataFont?.parentScheduleUserCode) {
        sheetSummary.getRow(indexDataFont + 6).font = {
          color: {
            argb: 'FFFF0000',
          },
        };
      }
    });

    try {
      await workbook.xlsx.writeBuffer().then(function (data) {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `Danh_Sach_Cong_Viec_Tu_${moment(filterNew?.DateFrom).format(
          'DD-MM-YYYY',
        )}_Den_${moment(filterNew?.DateTo).format('DD-MM-YYYY')}_Xuat_Excel_Luc_${moment().format('DD-MM-YY HH:mm')}.xlsx`; // name excel
        // anchor.download = `${moment().format('HH:mm')}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
      });
    } catch (error) {
      console.log({ error });
    } finally {
      setLoadingExport(false);
    }
  };

  const handleExportExcel = async (dataInit, filterNew) => {
    setLoadingExport(true);

    const filterParent = dataInit?.filter((el) => !el?.parentScheduleUserCode);

    // const dataParentIsFilter = filterParent
    //   ?.filter((parentIsFilter) => !parentIsFilter?.parentScheduleUserCode)
    //   ?.map((isFilter) => isFilter?.id);

    // =======================================================================================
    let dataFinal = [];
    filterParent?.map((item, index) => {
      const sttIndex = index + 1;
      dataFinal.push({
        ...item,
        stt: sttIndex,
        statusText: TASK_JOB_STATUS_OBJECT[item?.status || 0],
        arrAssignerText: item?.arrAssigner?.join(', '),
        arrManagerText: item?.arrManager?.join(', '),
        arrParentClientCompanyText:
          item?.arrParentClientCompany?.length > 0
            ? item?.arrParentClientCompany?.map((dataCompany) => dataCompany?.code)?.join(', ')
            : '',
      });

      const filterSubmenu = dataInit
        ?.filter((element) => element?.parentScheduleUserCode === item?.code)
        ?.map((dataSub, indexSub) => {
          dataSub.stt = Number(`${sttIndex}.${indexSub + 1}`);
          dataSub.statusText = TASK_JOB_STATUS_OBJECT[dataSub?.status || 0];
          dataSub.arrAssignerText = dataSub?.arrAssigner?.join(', ');
          dataSub.arrManagerText = dataSub?.arrManager?.join(', ');
          dataSub.arrParentClientCompanyText = dataSub?.clientCompanyCode || '';

          return dataSub;
        });

      if (filterSubmenu?.length > 0) {
        dataFinal.push(...filterSubmenu);
      }
    });

    if (dataFinal?.length > 0) {
      return exportExcel(dataFinal, filterNew);
    } else {
      setLoadingExport(false);
      return;
    }
  };

  // =======================================  Export Excel   =====================================================================

  const renderColumn = (
    <TableRow
      sx={{
        // backgroundColor: '#E8F9FF',
        // borderColor: 'blue',
        height: '50px',
        padding: '0px',
        padding: '8px',
      }}
    >
      <TableCell
        align="center"
        width={'50px'}
        sx={{
          borderTop: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        #
      </TableCell>
      <TableCell
        align="center"
        width={'100px'}
        minWidth="100px"
        sx={{
          borderTop: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        #
      </TableCell>
      <TableCell
        align="center"
        sx={{
          borderTop: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        <SearchInputColumnNew name="code" title="Mã công việc" onChange={onColumnSearch} />
      </TableCell>
      <TableCell
        align="center"
        sx={{
          borderTop: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        <SearchInputColumnNew name="name" title="Tên công việc" onChange={onColumnSearch} />
      </TableCell>
      <TableCell
        align="center"
        sx={{
          borderTop: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        <b>Trạng thái</b>
        <SelectionSearchColumn
          size="small"
          label=""
          name="status"
          dataArrObject={TASK_JOB_STATUS_OPTIONS}
          value={searchStatus}
          onChange={handleSearchSelect}
          displayNone={false}
        />
      </TableCell>
      <TableCell
        align="center"
        sx={{
          borderTop: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        <SearchInputColumnNew name="clientSearch" title="Khách hàng" onChange={onColumnSearch} />
      </TableCell>

      <TableCell
        align="center"
        sx={{
          borderTop: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        <div>T.gian bắt đầu</div>
        <DatePickerSearchColumn
          sx={{
            marginBottom: '10px',
            padding: 0,
          }}
          width={'140px'}
          marginTop="0"
          size="small"
          onChange={handleChangeSearchBeginWork}
          value={searchBeginWork}
          error={true}
          label=""
        />
      </TableCell>
      <TableCell
        align="center"
        sx={{
          borderTop: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        <div>T.gian kết thúc</div>
        <DatePickerSearchColumn
          sx={{
            marginBottom: '10px',
            padding: 0,
          }}
          width={'140px'}
          marginTop="0"
          size="small"
          onChange={handleChangeSearchEndWork}
          value={searchEndWork}
          error={true}
          label=""
        />
      </TableCell>

      {/* <TableCell
        align="center"
        sx={{
          borderTop: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        <SearchInputColumnNew
          name="workUpdateResult"
          title="Kết quả CV"
          onChange={onColumnSearch}
        />
      </TableCell> */}
      <TableCell
        align="center"
        sx={{
          borderTop: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        <SearchInputColumnNew name="createdBy" title="Người tạo" onChange={onColumnSearch} />
      </TableCell>
      <TableCell
        align="center"
        sx={{
          borderTop: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        <SearchInputColumnNew name="arrManager" title="Người liên quan" onChange={onColumnSearch} />
      </TableCell>
      <TableCell
        align="center"
        sx={{
          borderTop: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        <SearchInputColumnNew name="arrAssigner" title="Người T.Hiện" onChange={onColumnSearch} />
      </TableCell>

      <TableCell
        align="center"
        sx={{
          borderTop: '1px solid blue',
          borderRight: '1px solid blue',
          borderBottom: '1px solid blue',
          borderLeft: '1px solid blue',
          padding: '8px',
        }}
      >
        <SearchInputColumnNew name="workObjective" title="Mục tiêu CV" onChange={onColumnSearch} />
      </TableCell>
    </TableRow>
  );

  const renderHeader = (
    <>
      <ContainerHeader>
        <Stack spacing={2} direction="row">
          <Box sx={{ width: '160px' }}>
            <DatePicker
              sx={{
                marginBottom: '10px',
                padding: 0,
              }}
              width={100}
              marginTop="0"
              size="small"
              onChange={handleChangeStartDate}
              value={startDate}
              error={true}
              label="Từ ngày"
            />
          </Box>
          <Box sx={{ width: '160px' }}>
            <DatePicker
              sx={{
                marginBottom: '10px',
                padding: 0,
              }}
              width={100}
              marginTop="0"
              size="small"
              onChange={handleChangeEndDate}
              value={endDate}
              error={true}
              label="Đến ngày"
            />
          </Box>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox checked={isNotSuccess} onChange={handleChangeCheckboxIsNotSuccess} />
              }
              label="CV chưa hoàn thành"
            />
          </FormGroup>
          <IconButton
            aria-label="filter"
            sx={{ color: 'blue' }}
            onClick={() => handleSearchDate(startDate, endDate, isNotSuccess)}
          >
            <SearchIcon />
          </IconButton>
          {/* <IconButton aria-label="filter" sx={{ color: 'red' }}>
            <SearchOffIcon />
          </IconButton> */}
        </Stack>
      </ContainerHeader>

      {/* <IconButton aria-label="filter" sx={{ color: '#6C757D' }}>
        <BsFilter />
      </IconButton> */}
      {/* <ButtonImport
        variant="outlined"
        component="label"
        startIcon={<BsBoxArrowInUpRight />}
        disabled={loadingImport}
      >
        Nhập excel
        <input
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          type="file"
          hidden
          ref={inputRef}
          // onChange={onHandleImport}
        />
      </ButtonImport> */}
      <ButtonExport
        variant="outlined"
        startIcon={<BsArrowDownCircle />}
        onClick={() => handleExportExcel(originData, filter)}
        disabled={loadingExport}
      >
        Tải excel
      </ButtonExport>
      {/* <ButtonExport
        variant="outlined"
        startIcon={<BsFillStickiesFill />}
        // onClick={handleExportTemplate}
      >
        Biểu mẫu
      </ButtonExport> */}
      <ButtonAdd
        variant="contained"
        startIcon={<BsPlusCircle />}
        onClick={() => setSelected({ isNew: true })}
      >
        Thêm mới
      </ButtonAdd>
    </>
  );

  const handleChangePage = (_, newPage) => {
    setPage(newPage);

    const filterParent = originData?.filter((el) => !el?.parentScheduleUserCode);

    const pagingDataFormat = filterParent.filter((_, indexPaging) => {
      return newPage * rowsPerPage <= indexPaging && indexPaging < (newPage + 1) * rowsPerPage;
    });

    const dataFormat = pagingDataFormat?.map((item) => {
      const filterSubmenu = originData?.filter(
        (element) => element?.parentScheduleUserCode === item?.code,
      );
      item.submenus = filterSubmenu || [];
      item.isCollapse = COLLAPSE_INIT;
      return item;
    });

    setDataFormat(dataFormat || []);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowPerPage = +event.target.value;
    const pageSetup = 0;

    setRowsPerPage(newRowPerPage);
    setPage(pageSetup);

    const filterParent = originData?.filter((el) => !el?.parentScheduleUserCode);

    const pagingDataFormat = filterParent.filter((_, indexPaging) => {
      return (
        pageSetup * newRowPerPage <= indexPaging && indexPaging < (pageSetup + 1) * newRowPerPage
      );
    });

    const dataFormat = pagingDataFormat?.map((item) => {
      const filterSubmenu = originData?.filter(
        (element) => element?.parentScheduleUserCode === item?.code,
      );
      item.submenus = filterSubmenu || [];
      item.isCollapse = false;
      return item;
    });

    setDataFormat(dataFormat || []);
  };

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Typography variant="h6" component="h6" sx={{ marginBottom: '5px' }}>
          DANH SÁCH CÔNG VIỆC
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '20px 10px 5px 10px',
        }}
      >
        {renderHeader}
      </Box>
      <div
        style={{
          paddingLeft: '10px',
          paddingBottom: '5px',
          // color: 'blue',
        }}
      >
        {textDateSearch && textCheckboxSearch ? (
          <i>
            Bộ lọc hiện tại: Từ <span style={{ color: 'blue' }}>{textDateSearch}</span> và
            <span style={{ color: 'red' }}>{textCheckboxSearch}</span>
          </i>
        ) : (
          <i>Bộ lọc hiện tại:</i>
        )}
      </div>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: 'calc(100vh - 300px)',
          overflowY: 'auto',
        }}
      >
        <Table stickyHeader aria-label="collapsible table">
          <TableHead>{renderColumn}</TableHead>

          <TableBody>
            {dataFormat?.map((row, index) => (
              <Row
                key={`${row?.code}-${row?.name}-${index}`}
                row={row}
                deleteItem={deleteItem}
                setSelected={setSelected}
                usersList={usersList || []}
                handleShowDetailMainJob={handleShowDetailMainJob}
                handleShowDetailSubJob={handleShowDetailSubJob}
              />
            ))}
          </TableBody>
        </Table>
        <FormDetail {...{ selected, setSelected, reloadData }} />
        {/* // Update Main Job  */}
        <ModalFormDetail
          maxWidth="md"
          title={`Cập nhật: ${selectedShowModal?.code} `}
          open={selectedShowModal}
          onCloseModal={onCloseModal}
        >
          <UpdateJob
            selectedShowModal={selectedShowModal}
            setSelectedShowModal={setSelectedShowModal}
            onCloseModal={onCloseModal}
            reloadData={reloadData}
          />
        </ModalFormDetail>

        {/* // Update Sub Job  */}
        <ModalFormDetail
          maxWidth="md"
          title={`Cập nhật: ${selectedUpdateSubJob?.code}`}
          open={selectedUpdateSubJob}
          onCloseModal={handleCloseModalUpdateSubJob}
        >
          <UpdateSubJob
            dataMainJob={dataMainBySubJob}
            dataSubJob={selectedUpdateSubJob}
            onCloseUpdateSubJob={handleCloseModalUpdateSubJob}
            reloadData={reloadDataAfterUpdateSubJob}
          />
        </ModalFormDetail>
      </TableContainer>
      <TablePaginationCustom
        rowsPerPageOptions={[10, 20, 100]}
        // rowsPerPageOptions={[]}
        component="span"
        count={totalRecords || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        ActionsComponent={TablePaginationActions}
        labelRowsPerPage="Số dòng"
        showFirstButton={false}
      />

      <LoadingView loading={loading} />
    </>
  );
};

export { TaskJobPage };

export const TablePaginationCustom = styled(TablePagination)(({ theme }) => ({
  // width: '100vw',
  marginLeft: 0,
  padding: 0,
  maxHeight: 'calc(100vh - 350px)',
  '& .MuiTablePagination-selectLabel': {},
  '& .MuiTablePagination-displayedRows': {
    display: 'none',
  },
  '.MuiTablePagination-select': {
    borderRadius: '4px',
    border: '1px solid #DFDFDF',
  },
  '.MuiInputBase-colorPrimary': {
    margin: '10px',
  },
}));
